<template>
  <ValidationObserver v-slot="{ invalid }">

    <Loader cover v-if="isProcessing"/>

    <vx-card>

      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <ValidationProvider :name="$t('common-data.period-code')" rules="required" v-slot="{ errors }">
            <label class="text-sm opacity-75">{{ $t('common-data.period-code') + '*' }}</label>
            <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="academicPeriods"
                      :clearable="false"
                      label="periodCode"
                      selectOnTab
                      class="mb-4 md:mb-0"
                      v-model="selectedAcademicPeriod">
            </v-select>
            <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
          </ValidationProvider>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <ValidationProvider :name="$t('common-data.degree')" rules="required" v-slot="{ errors }">
            <label class="text-sm opacity-75">{{ $t('common-data.degree') + '*' }}</label>
            <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="degrees"
                      :clearable="false"
                      label="nameLocal"
                      selectOnTab
                      class="mb-4 md:mb-0"
                      v-model="selectedDegree">

              <!--label option-->
              <template #selected-option="{ nameLocal }">
                {{ nameLocal }}
              </template>

              <!--option list-->
              <template v-slot:option="option">
                {{ option.code }} {{ option.nameLocal }}
              </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
          </ValidationProvider>

        </div>

      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full">
          <vs-button @click="handlerExportExcelClick" :disabled="invalid"
          icon="icon-download" icon-pack="feather">
            {{$t('report.export-excel')}}
          </vs-button>
        </div>
      </div>

    </vx-card>

  </ValidationObserver>
</template>

<script>
import store from '@/store'
import vSelect from "vue-select";
import {APIServer} from "@/constants/config";

import {createNamespacedHelpers} from "vuex";
import AcademicPeriod from "@/store/modules/common-data/academic-period";
import AcademicPeriodConfig from "@/store/modules/common-data/academic-period-config";
import Degree from "@/store/modules/common-data/degree";

if (!store.state.AcademicPeriod) store.registerModule(`AcademicPeriod`, AcademicPeriod);
if (!store.state.AcademicPeriodConfig) store.registerModule(`AcademicPeriodConfig`, AcademicPeriodConfig);
if (!store.state.Degree) store.registerModule(`Degree`, Degree);

const {
  mapActions: mapStudentEnrollDetailActions,
} = createNamespacedHelpers(`StudentEnrollDetail`);
const {
  mapActions: mapAcademicPeriodActions,
} = createNamespacedHelpers(`AcademicPeriod`);
const {
  mapActions: mapAcademicPeriodConfigActions,
} = createNamespacedHelpers(`AcademicPeriodConfig`);
const {
  mapActions: mapDegreeActions,
} = createNamespacedHelpers(`Degree`);

export default {
  components: {
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
    vSelect
  },
  data() {
    return {
      isProcessing: false,
      subjectQty: 0,
      academicPeriods: [],
      degrees: [],
      currentAcademicPeriodConfig: {},
      selectedAcademicPeriod: {},
      selectedDegree: {},
    }
  },
  methods: {
    //---------------------------------------- State Function ------------------------------------------------------//
    ...mapStudentEnrollDetailActions({
      getAllStudentEnrollDetailsStat: 'getAllStudentEnrollDetailsStat',
    }),
    ...mapAcademicPeriodActions({
      getAcademicPeriods: 'getAcademicPeriods',
    }),
    ...mapAcademicPeriodConfigActions({
      getCurrentAcademicPeriodConfig: 'getCurrentAcademicPeriodConfig',
    }),
    ...mapDegreeActions({
      getDegrees: 'getDegrees',
    }),
    //---------------------------------------- Event Function ------------------------------------------------------//
    async handlerExportExcelClick(){
      this.isProcessing = true;

      const rsc = JSON.parse(localStorage.getItem("rsc"));
      let entity, stage
      if (rsc) {
        entity = rsc.e_code;
        stage = rsc.r_stage;
      }
      let url = APIServer
        + '/api/export_excel_all_student_stat'
        + '/' + this.selectedAcademicPeriod.id
        + '/' + this.selectedDegree.id
        + '/' + entity
        + '/' + stage;
      window.open(url, '_blank');

      this.isProcessing = false;
    },
    async initData() {
      this.isProcessing = true;
      this.academicPeriods = await this.getAcademicPeriods();
      this.degrees = await this.getDegrees();
      this.currentAcademicPeriodConfig = await this.getCurrentAcademicPeriodConfig();

      if (this.academicPeriods && this.academicPeriods.length > 0) {
        this.selectedAcademicPeriod = this.academicPeriods.find(item => {
          return item.periodCode === this.currentAcademicPeriodConfig.learnPeriodCode
        });
      }
      if(this.degrees && this.degrees.length > 0){
        this.selectedDegree = this.degrees[0]
      }
      this.isProcessing = false;
    },
  },
  async beforeMount() {
    await this.initData();
  }
}
</script>

<style scoped>

</style>
